import { cn } from '@/lib/utils'

/** Full Opsyri logo with wordmark */
export function OpsyriLogo({ className }: { className?: string }) {
  return (
    <img
      src="/opsyri-logo.svg"
      alt="Opsyri"
      className={cn('h-8', className)}
    />
  )
}

/** Icon-only version (gear O) for compact spaces */
export function OpsyriIcon({ className, size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="opsyri-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00c9a7" />
          <stop offset="100%" stopColor="#007a5e" />
        </linearGradient>
      </defs>
      {/* Rounded body */}
      <path
        d="M90,49.219 L90,58.781 C90,78.219 72.077,94 50,94 C27.923,94 10,78.219 10,58.781 L10,49.219 C10,29.781 27.923,14 50,14 C72.077,14 90,29.781 90,49.219Z"
        fill="url(#opsyri-grad)"
      />
      {/* Inner O ring */}
      <circle cx="50" cy="54" r="22" fill="none" stroke="white" strokeWidth="6" />
      {/* Gear teeth */}
      <rect x="46" y="26" width="8" height="8" rx="2" fill="white" />
      <rect x="46" y="74" width="8" height="8" rx="2" fill="white" />
      <rect x="22" y="50" width="8" height="8" rx="2" fill="white" />
      <rect x="70" y="50" width="8" height="8" rx="2" fill="white" />
      {/* Diagonal teeth */}
      <rect x="28" y="33" width="7" height="7" rx="2" fill="white" transform="rotate(45 31.5 36.5)" />
      <rect x="65" y="33" width="7" height="7" rx="2" fill="white" transform="rotate(45 68.5 36.5)" />
      <rect x="28" y="68" width="7" height="7" rx="2" fill="white" transform="rotate(45 31.5 71.5)" />
      <rect x="65" y="68" width="7" height="7" rx="2" fill="white" transform="rotate(45 68.5 71.5)" />
    </svg>
  )
}
